const AVATAR_COLORS = [
  'red.400',
  'orange.400',
  'yellow.400',
  'green.400',
  'teal.400',
  'blue.400',
  'cyan.400',
  'purple.400',
  'pink.400',
]

export const getAvatarColorFromName = (name: string) => {
  const safe = (name || '').trim()
  if (!safe) return 'gray.400'

  let hash = 0
  for (let i = 0; i < safe.length; i++) {
    hash = safe.charCodeAt(i) + ((hash << 5) - hash)
  }

  const index = Math.abs(hash) % AVATAR_COLORS.length
  return AVATAR_COLORS[index]
}
